export default __webpack_public_path__ + "static/media/Group 10409.2c67c692.svg";